var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-form",
    {
      attrs: { autocomplete: "off", id: "source_submit" },
      on: { submit: _vm.onSubmit }
    },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-sm-12 col-md-12 col-lg-12" },
          [
            _c(
              "b-form",
              [
                _c(
                  "b-form-group",
                  { attrs: { label: "Название", "label-for": "title" } },
                  [
                    _c("b-form-input", {
                      attrs: { id: "title", size: "sm", type: "text" },
                      model: {
                        value: _vm.userGroup.item.title,
                        callback: function($$v) {
                          _vm.$set(_vm.userGroup.item, "title", $$v)
                        },
                        expression: "userGroup.item.title"
                      }
                    }),
                    _vm._v(" "),
                    _vm.submitted && _vm.nameValidateMessage
                      ? _c("span", { staticClass: "alert-danger" }, [
                          _vm._v(_vm._s(_vm.nameValidateMessage))
                        ])
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-form-group",
                  { attrs: { "label-for": "users" } },
                  [
                    _c(
                      "v-select",
                      {
                        attrs: {
                          options: _vm.availableUsers,
                          label: "name",
                          required: "",
                          multiple: ""
                        },
                        model: {
                          value: _vm.userGroup.item.users,
                          callback: function($$v) {
                            _vm.$set(_vm.userGroup.item, "users", $$v)
                          },
                          expression: "userGroup.item.users"
                        }
                      },
                      [
                        _c(
                          "span",
                          { attrs: { slot: "no-options" }, slot: "no-options" },
                          [_vm._v("Совпадений не найдено.")]
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    staticClass: "float-right",
                    attrs: { type: "submit", variant: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.onSubmit($event, true)
                      }
                    }
                  },
                  [_vm._v("Сохранить и выйти\n        ")]
                ),
                _vm._v(" "),
                _vm.submitted && _vm.message
                  ? _c("span", { staticClass: "alert-danger" }, [
                      _vm._v(_vm._s(_vm.message))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "form-errors" })
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-errors" })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-00449d97", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00449d97","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/views/front/modals/EditUserGroupModal.vue
// module id = 1080
// module chunks = 0